import React, { Component } from 'react'

import { translation } from '../../../utils/helpers'

import './panelheader.scss'
import Inline from '../inline'
import Icon from '../icon'

/**
 * Renders a header, optionally with an icon and/or helptext.
 * Any child components will be aligned to the right edge of the header.
 */
class PanelHeader extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    // Empty header with correct spacing in relation to other headers
    let text = this.props.text
    if (typeof text === 'number') text = translation(text)
    let headerText = () => <h3>&#8203;</h3>
    if (this.props.text) {
      headerText = () => <h3>{text}</h3>
    }

    let header = () => headerText()
    if (this.props.icon !== null) {
      header = () => (
        <Inline fillChildNum={[1]} alignChildren='center' block>
          <Icon size='s' icon={this.props.icon} />
          {headerText()}
        </Inline>
      )
    }

    return (
      <div className='element-header'>
        {header()}
        {this.props.children}
      </div>
    )
  }

}

PanelHeader.defaultProps = {
  text: 'Header text',
  icon: null,
  helpText: null
}

export default PanelHeader



// WEBPACK FOOTER //
// ./src/app/shared/elements/panelHeader/index.js